import React from "react";
var __jsx = React.createElement;
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { BlockType } from '@uno/common-cms';
import { Blocks } from 'components/common/RichTextEditor/types';
import { Delete, EditCircle } from 'theme/icons';
import { Container } from './EditSelectedBlockToolbar.style';

var EditSelectedBlockToolbar = function EditSelectedBlockToolbar(_ref) {
  var block = _ref.block,
      unselectAndRemoveBlock = _ref.unselectAndRemoveBlock,
      updateBlockData = _ref.updateBlockData,
      contentState = _ref.contentState;
  var intl = useIntl();
  var removeBlockCallBack = useCallback(function () {
    return unselectAndRemoveBlock(block.getKey());
  }, [unselectAndRemoveBlock, block]);

  var isBlockEditable = function isBlockEditable() {
    if (block.getType() === BlockType.ATOMIC) {
      var _Blocks$type$isEditab, _Blocks$type;

      var type = contentState.getEntity(block.getEntityAt(0)).getType();
      return (_Blocks$type$isEditab = (_Blocks$type = Blocks[type]) === null || _Blocks$type === void 0 ? void 0 : _Blocks$type.isEditable) !== null && _Blocks$type$isEditab !== void 0 ? _Blocks$type$isEditab : false;
    }

    return false;
  };

  var onEditClickCallback = useCallback(function () {
    updateBlockData(block.getKey(), {
      openModal: true
    });
  }, [block, updateBlockData]);
  return __jsx(Container, null, isBlockEditable() && __jsx(EditCircle, {
    onClick: onEditClickCallback
  }), __jsx(Delete, {
    onClick: removeBlockCallBack,
    "aria-label": intl.formatMessage({
      id: 'content.labels.block-toolbar.remove-block'
    })
  }));
};

export default EditSelectedBlockToolbar;